module.exports = __webpack_public_path__ + "static/media/72.4c949dd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/72.jpg
// module id = 631
// module chunks = 0